<template>
    <div>
        <div class="mt-4 md:grid md:grid-cols-6 md:gap-6">
            <div class="sm:col-span-2">
                <label for="type" class="block text-sm font-medium leading-5 text-gray-700">
                    {{ $t('messages.intervention_with') }}
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                    <FormSelect id="type" name="type" required v-model="type" :options="types" />
                </div>
            </div>

            <div class="sm:col-span-2" v-show="type" v-if="assessmentLevels.length">
                <label for="assessment_level" class="block text-sm font-medium leading-5 text-gray-700">
                    {{ $t('messages.intervention_status') }}
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                    <FormSelect
                        id="assessment_level"
                        name="assessment_level"
                        required
                        v-model="assessmentLevel"
                        :options="assessmentLevels"
                    />
                </div>
            </div>

            <div class="sm:col-span-6">
                <label for="evaluation_of_intervention" class="block text-sm font-medium leading-5 text-gray-700">
                    {{ $t('messages.evaluation_of_intervention') }}
                </label>
                <div class="mt-1">
                    <textarea
                        id="evaluation_of_intervention"
                        v-model="evaluationOfIntervention"
                        name="evaluation_of_intervention"
                        rows="3"
                        class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
                    ></textarea>
                </div>
            </div>
        </div>

        <div class="mt-5" v-if="selectedAssessmentLevel">
            <!--                v-model="selectedAssessmentLevel"-->
            <div class="rounded-md bg-gray-50 px-6 py-5 sm:flex sm:items-start sm:justify-between">
                <div class="sm:flex sm:items-start">
                    <div class="shrink-0 w-2.5 h-2.5 rounded-full" :class="selectedAssessmentLevel.bgColor"></div>
                    <div class="mt-3 sm:mt-0 sm:ml-4">
                        <div class="text-sm leading-5 font-medium text-gray-900">
                            <div class="flex items-center">
                                {{ selectedAssessmentLevel.text }}

                                <transition
                                    enter-active-class="transition-opacity ease-linear duration-300"
                                    enter-from-class="opacity-0"
                                    enter-to-class="opacity-100"
                                    leave-active-class="transition-opacity ease-linear duration-300"
                                    leave-from-class="opacity-100"
                                    leave-to-class="opacity-0"
                                >
                                    <span
                                        v-show="evaluationOfIntervention === ''"
                                        @click="evaluationOfIntervention = selectedAssessmentLevel.explanation"
                                        class="cursor-pointer"
                                    >
                                        <IconClipboard class="w-4 h-4 ml-2 text-gray-600" />
                                    </span>
                                </transition>
                            </div>
                        </div>
                        <div class="mt-1 text-sm leading-5 text-gray-600 sm:flex sm:items-center">
                            <div>
                                {{ selectedAssessmentLevel.explanation }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InterventionTypeLevel',
};
</script>

<script setup>
import { computed } from 'vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import { useVModel } from '@vueuse/core';
import { IconClipboard } from '@tabler/icons-vue';

const props = defineProps({
    assessments: {
        required: true,
        type: Array,
    },
    types: {
        required: true,
        type: Array,
    },
    typeInput: {
        required: false,
        default: '',
    },
    assessmentLevelInput: {
        required: false,
        default: null,
    },
    evaluationOfInterventionInput: {
        required: false,
        default: '',
    },
});

const emit = defineEmits(['update:typeInput', 'update:assessmentLevelInput', 'update:evaluationOfInterventionInput']);

const type = useVModel(props, 'typeInput', emit);
const evaluationOfIntervention = useVModel(props, 'evaluationOfInterventionInput', emit);
const assessmentLevel = useVModel(props, 'assessmentLevelInput', emit);

// const types = [
//     {
//         value: '',
//         text: 'messages.select',
//         disabled: true,
//     },
//     {
//         value: 'student',
//         text: 'messages.student',
//         disabled: false,
//     },
//     {
//         value: 'family',
//         text: 'messages.family',
//         disabled: false,
//     },
//     {
//         value: 'other',
//         text: 'messages.other',
//         disabled: false,
//     },
// ];

const selectedAssessmentLevel = computed(() => {
    if (assessmentLevel.value) {
        return assessmentLevels.value.find((e) => e.value === assessmentLevel.value);
    }
    return null;
});

const assessmentLevels = computed(() => {
    return props.assessments.filter((a) => a.type === type.value);
});
</script>
